export const niveau1 = [
  {
    value: 1,
    label: "MP2IA",
  },
  {
    value: 2,
    label: "MP2IB",
  },
  {
    value: 3,
    label: "SRIT 1A",
  },
  {
    value: 4,
    label: "SRIT 1B",
  },
  {
    value: 5,
    label: "SRIT 1C",
  },
  {
    value: 6,
    label: "TWIN 1",
  },
  {
    value: 7,
    label: "ENTD",
  },
 
];
  
export const niveau2 = [
  {
    value: 1,
    label: "SRIT 2A",
  },
  {
    value: 2,
    label: "SRIT 2B",
  },
  {
    value: 3,
    label: "RTEL 2",
  },
  {
    value: 4,
    label: "SIGL 2",
  },
  {
    value: 5,
    label: "TWIN 2",
  },
  {
    value: 6,
    label: "CSIA 2",
  },
  {
    value: 7,
    label: "SRIT 3A",
  },
  {
    value: 8,
    label: "SRIT 3B",
  },
  {
    value: 9,
    label: "RTEL 3",
  },
  {
    value: 10,
    label: "SIGL 3",
  },
  {
    value: 11,
    label: "TWIN 3",
  },
];
  
export const niveau3 = [
  {
    value: 1,
    label: "Master CSIA",
  },
  {
    value: 2,
    label: "Master 1 SIGL",
  },
  {
    value: 3,
    label: "Master 1 MBDS",
  },
  {
    value: 4,
    label: "Master 1 BIHAR",
  },
  {
    value: 5,
    label: "Master 1 ERIS",
  },
  {
    value: 6,
    label: "Master 1 MDSI",
  },
  {
    value: 7,
    label: "Master 2 SITW",
  },
  {
    value: 8,
    label: "Master 2 SIGL",
  },
  {
    value: 9,
    label: "Master 2 MBDS",
  },
  {
    value: 10,
    label: "Master 2 BIHAR",
  },
  {
    value: 11,
    label: "Master 2 ERIS",
  },
  {
    value: 12,
    label: "Master 2 MDSI",
  },
];
  
export const niveau3Out = [
  {
    value: 1,
    label: "Niveau 3 Sécurité",
  },
  {
    value: 2,
    label: "Niveau 3 SIGL",
  },
  {
    value: 3,
    label: "Niveau 3 Sécurité",
  },
];
  
export const baseLevel = [
  {
    value: 1,
    label: "Niveau 1",
  },
  {
    value: 2,
    label: "Niveau 2 Developpement",
  },
  {
    value: 3,
    label: "Niveau 2 Réseau",
  },
  {
    value: 4,
    label: "Niveau 3 Sécurité",
  },
  {
    value: 5,
    label: "Niveau 3 Developpement",
  },
  {
    value: 6,
    label: "Niveau 3 Réseau",
  },
];
  
export const otherSchool = [
  {
    value: 1,
    label: "INPHB",
  },
  {
    value: 2,
    label: "ISTC",
  },
  {
    value: 3,
    label: "IIT",
  },
  {
    value: 4,
    label: "Miage",
  },
  {
    value: 5,
    label: "Université virtuelle",
  },
  {
    value: 6,
    label: "Autre",
  },
];
  
export const baseListGender = [
  {
    value: 1,
    label: "Masculin",
  },
  {
    value: 2,
    label: "Féminin",
  },
];
  
export const baseClassList = [
  {
    classe: "SRIT 1A",
    limit: 4,
  },
  {
    classe: "SRIT 1B",
    limit: 4,
  },
  {
    classe: "SRIT 1C",
    limit: 4,
  },
];
  
export const baseListYear = [
  {
    value: 1,
    label: "-- Choisissez --",
  },
  {
    value: 2,
    label: "2020",
  },
  {
    value: 3,
    label: "2021",
  },
  {
    value: 4,
    label: "2022",
  },
  {
    value: 5,
    label: "2023",
  },
  {
    value: 6,
    label: "2024",
  },
  {
    value: 7,
    label: "2025",
  },
  {
    value: 8,
    label: "2026",
  },
  
];
  
export const mealList = [
  {
    label: "attiéké poulet",
  },
  {
    label: "attiéké poisson",
  },
  {
    label: "Tchiep poulet",
  },
  {
    label: "Tchiep Poisson",
  },
];
  
export const drinkList = [
  {
    label: "Café au lait",
  },
  {
    label: "Thé",
  },
  {
    label: "Mix café & Thé",
  },
  {
    label: "Dêguê",
  },
];
  
export const rankList = [
  {
    label: "Equipe 1",
    rang: "1",
  },
  {
    label: "Equipe 2",
    rang: "2",
  },
  {
    label: "Equipe 3",
    rang: "3",
  },
  {
    label: "Equipe 4",
    rang: "4",
  },
  {
    label: "Equipe 5",
    rang: "5",
  },
];
  
export const teamsGroup1 = [
  {
    label: "Equipe 1 groupe 1",
    rang: "3",
  },
  {
    label: "Equipe 2 groupe 1",
    rang: "4",
  },
  {
    label: "Equipe 3 groupe 1",
    rang: "80",
  },
  {
    label: "Equipe 4 groupe 1",
    rang: "65",
  },
  {
    label: "Equipe 5 groupe 1",
    rang: "34",
  },
];
  
export const teamsGroup2 = [
  {
    label: "Equipe 1 groupe 2",
    rang: "3",
  },
  {
    label: "Equipe 2 groupe 2",
    rang: "4",
  },
  {
    label: "Equipe 3 groupe 2",
    rang: "80",
  },
  {
    label: "Equipe 4 groupe 2",
    rang: "65",
  },
  {
    label: "Equipe 5 groupe 2",
    rang: "34",
  },
];
  
export const teamsGroup3 = [
  {
    label: "Equipe 1 groupe 3",
    rang: "3",
  },
  {
    label: "Equipe 2 groupe 3",
    rang: "4",
  },
  {
    label: "Equipe 3 groupe 3",
    rang: "80",
  },
  {
    label: "Equipe 4 groupe 3",
    rang: "65",
  },
  {
    label: "Equipe 5 groupe 3",
    rang: "34",
  },
];